import { useState } from "react";
import { FormControl,InputLabel,Select,MenuItem,IconButton } from "@mui/material";
import axios from "axios";
import CompanySelect from "../Universal/CompanySelect";
import CompanyAutoselect from "../Universal/CompanyAutoselect";



function PeerAssignCompany(props)
{
    //Selected Company in Select form control
    const [selectedCompany,setSelectedCompany] = useState({});
    
    //Called when we change the select
    const assignCompany=(e)=>
    {
        if(e && e.id>0){
        setSelectedCompany(e.id);
        //Find the company
        let company = props.allCompanies.find((c)=>c.companyId===e.id);
        company.peerGroupId = props.selectedPeerGroupId;
        //Make a call to put the company with Peer Group Id
        axios({
            // Endpoint to send files
            url: process.env.REACT_APP_API_URL+'PeerGroupCompany',
            method: "POST",
            data:{
                companyId:company.companyId,
                peerGroupId:company.peerGroupId
             },
        }).then((res) => {            
            //Change up the list of AllCompanies
            props.setAllCompanies(props.allCompanies.map((c)=>c.companyId===company.companyId?{...c,peerGroupId:company.peerGroupId}:c));
            //Add this to peerCompanies
            props.setPeerCompanies([...props.peerCompanies,company]);
        }).catch((err) => {
            console.log(err)
        });
        }
    };
    return(
    <>
        <CompanyAutoselect allCompanies={props.allCompanies} showAllCompanies={true} onChange={assignCompany} selectText="Company" headerText="Assign Company"></CompanyAutoselect>
    </>
    );
}

export default PeerAssignCompany;